/**
 * @desc 查询年计划tab页标题名称
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanYearTabResponse>>> {
  return defHttp.post({
    url: '/wap/plan/year/queryPlanTabs',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanYearTabResponse>>> {
  return defHttp.post({
    url: '/mock/wap/plan/year/queryPlanTabs',
    data,
  });
}
